import { Stack } from '@optimus-web/core';
import { DefaultErrorBoundary } from '@mews-commander/ui';
import Tasks from '../tasks/Tasks';
import { CustomersTable } from '../CustomersTable';
import { AvailabilityBlockCard } from '../AvailabilityBlockCard';
import CheckOutFormCard from './CheckOutFormCard';
import ReservationConfirmationFormCard from './ReservationConfirmationFormCard';
import OptionalFormCard from './OptionalFormCard';
import ReservationCancellationFormCard from './ReservationCancellationFormCard';
import UndoCheckInFormCard from './UndoCheckInFormCard';
import UndoCheckOutFormCard from './UndoCheckOutFormCard';
import { ResourceAssignTableCard } from './ResourceAssigntableCard';
import UndoCancellationFormCard from './UndoCancellationFormCard';

interface Props {
    scope: string;
    serviceId: string;
    refetchGroup: () => void;
}
const StateTab = ({ scope, refetchGroup, serviceId }: Props) => (
    <DefaultErrorBoundary>
        <Stack spacing="200" vertical>
            <AvailabilityBlockCard scope={scope} />
            {/* @ts-expect-error $TSFixMeError: JSX element type 'CustomersTable' does not have any construct or call signatures. */}
            <CustomersTable scope={scope} refetchGroup={refetchGroup} serviceId={serviceId} />
            <ResourceAssignTableCard scope={scope} />
            <CheckOutFormCard scope={scope} form={`check-out-form-${scope}`} serviceId={serviceId} />
            <OptionalFormCard scope={scope} form={`optional-form-${scope}`} />
            <ReservationConfirmationFormCard
                scope={scope}
                form={`reservation-confirmation-form-${scope}`}
                serviceId={serviceId}
            />
            <ReservationCancellationFormCard
                scope={scope}
                form={`reservation-cancellation-form-${scope}`}
                serviceId={serviceId}
            />
            <UndoCancellationFormCard
                scope={scope}
                form={`undo-cancellation-form-${scope}`}
                refetchGroup={refetchGroup}
            />
            <UndoCheckInFormCard scope={scope} form={`undo-check-in-form-${scope}`} />
            <UndoCheckOutFormCard scope={scope} form={`undo-check-out-form-${scope}`} />
            <Tasks scope={scope} />
        </Stack>
    </DefaultErrorBoundary>
);
export default StateTab;
